import { User } from '../types';

/**
 * Merges fresh profile data without dropping the credentials of a saved
 * account. The /user payload intentionally does not include refresh_token.
 */
export const mergeSavedUserSession = (
    savedUser: User | undefined,
    freshUser: User,
    token: string,
    refreshToken?: string | null,
): User => {
    const nextRefreshToken = refreshToken ?? freshUser.refresh_token ?? savedUser?.refresh_token;

    return {
        ...savedUser,
        ...freshUser,
        token,
        ...(nextRefreshToken ? { refresh_token: nextRefreshToken } : {}),
    };
};

/**
 * Removes a saved account without touching any other cached identities.
 */
export const removeSavedUserSession = (
    savedUsers: User[],
    userId: number,
): User[] => savedUsers.filter(savedUser => savedUser.id !== userId);
